import dayjs from "dayjs";
import {useCallback, useMemo} from "react";
import {useTranslation} from "react-i18next";

const useTimeFormat = () => {
  const {i18n} = useTranslation();
  const rtf = useMemo(
    () =>
      new Intl.RelativeTimeFormat(i18n.language.includes("en") ? "en" : "de", {
        numeric: "auto",
      }),
    [i18n.language],
  );

  const formatRelativeTime = useCallback(
    (date: dayjs.Dayjs) => {
      const now = dayjs();
      const diffInSeconds = now.diff(date, "seconds");
      if (diffInSeconds < 3600) {
        return rtf.format(-Math.floor(diffInSeconds / 60), "minute");
      } else if (diffInSeconds < 86400) {
        return rtf.format(-Math.floor(diffInSeconds / 3600), "hour");
      } else if (diffInSeconds < 2592000) {
        return rtf.format(-Math.floor(diffInSeconds / 86400), "day");
      } else {
        return date.format("DD MMM YYYY");
      }
    },
    [rtf],
  );
  return formatRelativeTime;
};

export {useTimeFormat};
